export const isDebugIdleModal = false;

// USED FOR POLLING TIMER
export const POLLING_INTERVAL_SECONDS = isDebugIdleModal ? 4 : 60; // timer refresh every 1sec or 1 minute
export const POLLING_INTERVAL_MILLISECONDS = POLLING_INTERVAL_SECONDS * 1000;

// USED FOR SETTING COOKIE session_idle_expiry_time
export const IDLE_TIMEOUT_DURATION = isDebugIdleModal ? 15 : 2;
export const IDLE_TIMEOUT_TIME_UNIT = isDebugIdleModal ? 'second' : 'hour';
